module.exports = __webpack_public_path__ + "03_short_yellow.84accc84.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/03_short_yellow.png
// module id = KzCE
// module chunks = 0